/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    ['assets/js/modules/pricing/pricingModel', 'assets/js/modules/utils', 'assets/js/modules/pricing/percentageSubPricingModel'],
    function(PricingModel, utils, PercentageSubPricingModel) {
        return PricingModel.extend({
            defaults: {
                strategy: 'price_per_quantity',
                price: 0,
                currency: null,
                quantity: 0,
                basePrice: 0
            },
            /**
             * @param {Object} context
             * @returns {number}
             */
            getPrice: function(context) {
                var quantity = context.quantity,
                    percentage = 1;

                if (context.currentOptionValue !== undefined) {
                    context.selectedOptionValues.forEach(function(optionValue) {
                        if (context.currentOptionValue.get('optionValueRequirements').includes(optionValue.get('name')) === false) {
                            return;
                        }

                        if (optionValue.get('pricing') instanceof PercentageSubPricingModel) {
                            percentage = optionValue.get('pricing').get('percentage');
                        }
                    });
                }

                var pricePerQuantity = percentage * this.get('price') * quantity / this.get('quantity');

                return utils.roundFloat(pricePerQuantity + this.get('basePrice'));
            },

            toString: function(context) {
                context = context || {};
                var quantity = context.quantity || this.get('quantity');
                var cardsName = context.cardsName !== undefined ? context.cardsName : ' cards';

                var price = this.getPrice({ quantity: quantity });
                if (this.get('price') === 0) {
                    return utils.formatPrice(price, this.get('currency'));
                }
                // show "$5 per 100" instead of "$0.05 per 1"
                while (price < 1) {
                    quantity *= 10;
                    price = this.getPrice({ quantity: quantity });
                }

                if (quantity === 1) {
                    return utils.formatPrice(price, this.get('currency')) + ' each';
                }

                return utils.formatPrice(price, this.get('currency')) + ' per ' + quantity + cardsName;
            }
        });
    }
);
